import { render, staticRenderFns } from "./CertifikatJavnoPDF.vue?vue&type=template&id=5fb76a99&scoped=true&"
import script from "./CertifikatJavnoPDF.vue?vue&type=script&lang=js&"
export * from "./CertifikatJavnoPDF.vue?vue&type=script&lang=js&"
import style0 from "./CertifikatJavnoPDF.vue?vue&type=style&index=0&id=5fb76a99&scoped=true&lang=css&"
import style1 from "./CertifikatJavnoPDF.vue?vue&type=style&index=1&id=5fb76a99&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb76a99",
  null
  
)

export default component.exports